import {useState} from 'react'
import Modal from '@mui/material/Modal'
import './HangingMenus.css'
import { saraswathi_mail } from '../utils/mailIds'

const HangingMenus = () => {
    const [show, setShow] = useState(false);
    const [showBot, setShowBot] = useState(false);        
  
    const handleOpenModal = () => {
        setShow(true);
    };
  
    const handleCloseModal = () => {
        setShow(false);
    };    

    const handleBot = () => {        
        setShowBot(!showBot);                
    }                

    return (
        <div className="socialMediaWrap" id="home">                                   
            <button onClick={handleOpenModal} className="iconBtn icon1">
                <img src={process.env.PUBLIC_URL + '/images/SocialLearning/present.svg'} alt="ips-icon" />
                <span>Request for Training</span>
            </button>
            <Modal
                open={show}
                onClose={handleCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div className="model-container">
                <span className="close_btn_model_reqtraining" onClick={handleCloseModal}>
                    X
                </span>
                <h4>Request For Training</h4>
                <div className="model_heading_reqtraining">
                    <p className="model_name_reqtraining">
                    <a
                        href="https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Link to raise training request
                    </a>
                    </p>
                    <div className="modal_content_reqtraining">
                    For further queries please get in touch with <br />
                    </div>
                    <p className="model_contact_reqtraining">
                    <a href={`mailto:${saraswathi_mail}`} target="_blank" rel="noreferrer">
                        Swaminathan, Saraswathi.
                    </a>
                    </p>
                </div>
                </div>
            </Modal>            
            {/* <button className="iconBtn icon2">
                <a
                href="https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxMDU4MzIwMzAyMDgifQ/all"
                target="_blank"
                rel="noreferrer"
                >
                <img src={process.env.PUBLIC_URL + '/images/SocialLearning/Yammer1.png'} alt="ips-icon" />
                <span>Connect with Community</span>
                </a>
            </button>
            <button className="iconBtn icon3">
                <img src={process.env.PUBLIC_URL + '/images/SocialLearning/mail.svg'} alt="ips-icon" />
                <span>Contact Us</span>
                </a>
            </button> */}
        </div>
    )
}

export default  HangingMenus